import { useQuery } from "@tanstack/react-query";

import { calendarApi, type CalendarRangeQuery } from "@/lib/api";

export const calendarQueryKey = (q: CalendarRangeQuery) =>
  ["calendar", q.room_id ?? "all", q.starts_at, q.ends_at] as const;

export function useCalendarFeed(q: CalendarRangeQuery, enabled = true) {
  return useQuery({
    queryKey: calendarQueryKey(q),
    queryFn: () => calendarApi.feed(q),
    enabled,
    staleTime: 30_000,
  });
}
